import { Configuration } from '@azure/msal-browser';

const clientId = import.meta.env.VITE_ADB2C_CLIENT_ID!;
const authority = import.meta.env.VITE_ADB2C_AUTHORITY!;
const redirectUri = import.meta.env.VITE_ADB2C_REDIRECT_URI!;
const knownAuthorities = import.meta.env.VITE_ADB2C_KNOWNAUTHORITIES!;

if (!(clientId && authority && redirectUri && knownAuthorities)) {
  console.error('Invalid authentication configuration');
}

const authConfig: Configuration = {
  auth: {
    clientId,
    authority,
    redirectUri,
    knownAuthorities: [knownAuthorities],
  },
};

export default authConfig;
